'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { FormFieldContext } from '../form-field/context/form-field.context';
import { radioRecipe } from './styles/radio.styles';
import type { RadioPropsInterface } from './types/radio.types';

/**
 * @since 1.8.0
 */

export const Radio = forwardRef<HTMLInputElement, RadioPropsInterface>(
  (props: RadioPropsInterface, forwardedRef) => {
    const formFieldContext = useContext(FormFieldContext);

    const {
      className,
      css: cssProp,
      disabled = formFieldContext.disabled || false,
      readOnly = formFieldContext.readOnly || false,
      required = formFieldContext.required || false,
      ...rest
    } = props;

    const styles = css(radioRecipe.raw({ disabled }), cssProp);

    return (
      <input
        type="radio"
        aria-describedby={formFieldContext.descriptionId}
        ref={forwardedRef}
        id={formFieldContext.controlId}
        className={cx('c11n', 'c11n_radio', styles, className)}
        data-c11n-component="Radio"
        data-c11n-version={__C11N_VERSION__}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
        {...rest}
      />
    );
  },
);

Radio.displayName = 'Radio';
